export { default } from "./addReadPageIdentifier";
